import React from 'react';
import { Link } from 'react-router-dom';

function ServiceCard({ title, description, route, image }) {
  return (
    <div className="service-card">
      <img src={image} alt={title} className="service-card-image" />
      <h3 className="service-card-title">{title}</h3>
      <p className="service-card-description">{description}</p>
      <Link to={route} className="service-card-link">Acceder</Link>
    </div>
  );
}

export default ServiceCard;
